export type SortDirection = 'asc' | 'desc';

export type SortValue = {
  field: string;
  direction: SortDirection;
};

export function getNextSortValue(value: SortValue[], field: string): SortValue[] {
  const current = value.find((item) => item.field === field);
  if (current === undefined) {
    return [...value, { field, direction: 'asc' }];
  }
  if (current.direction === 'asc') {
    return value.map((item) => (item.field === field ? { field, direction: 'desc' } : item));
  }
  return value.filter((item) => item.field !== field);
}
